import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=2d4ec52a&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=2d4ec52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ec52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4ec52a')) {
      api.createRecord('2d4ec52a', component.options)
    } else {
      api.reload('2d4ec52a', component.options)
    }
    module.hot.accept("./MainTable.vue?vue&type=template&id=2d4ec52a&scoped=true&", function () {
      api.rerender('2d4ec52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/components/MainTable.vue"
export default component.exports